// TBA relocate the newsletter signup/announcement bar into the header section

var animationQueue = {};

// Helper - Slide down
function newsletterSlideDown(element, callback) {
  var propertyToAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'height';

  // To do the animation we temporarily hide it, check the height, and transition to it
  element.style[propertyToAnimate] = element.scrollHeight + 'px';

  var transitionEnded = function transitionEnded(event) {
    if (event.propertyName === propertyToAnimate) {
      var defaultValue = 'auto';

      if (propertyToAnimate === 'max-height') {
        defaultValue = 'none';
      }

      element.style[propertyToAnimate] = defaultValue; // Allows the content to grow normally
      element.removeEventListener('transitionend', transitionEnded);
      delete animationQueue[element.id];

      (callback || function () {})();
    }
  };

  element.addEventListener('transitionend', transitionEnded);
  animationQueue[element.id] = transitionEnded;
}

// Helper - Slide up
function newsletterSlideUp(element, callback) {
  var propertyToAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'height';

  element.style[propertyToAnimate] = element.scrollHeight + 'px'; // Force previous height to allow CSS transition
  element.offsetHeight; // Force redraw
  element.style[propertyToAnimate] = 0;

  if (animationQueue[element.id]) {
    element.removeEventListener('transitionend', animationQueue[element.id]);
    delete animationQueue[element.id];
  }

  var transitionEnded = function transitionEnded(event) {
    if (event.propertyName === 'height') {
      element.removeEventListener('transitionend', transitionEnded);
      (callback || function () {})();
    }
  };

  element.addEventListener('transitionend', transitionEnded);
}


// Helper - trap focus
function newsletterTrapFocus(container, namespace) {

  this.listeners = this.listeners || {};

  // We check if there is an element with the attribute "autofocus"
  var elementToFocus = container.querySelector('[autofocus]') || container;

  container.setAttribute('tabindex', '-1');
  elementToFocus.focus();

  this.listeners[namespace] = function (event) {
    if (container !== event.target && !container.contains(event.target)) {
      elementToFocus.focus();
    }
  };

  document.addEventListener('focusin', this.listeners[namespace]);
}
function newsletterRemoveTrapFocus(container, namespace) {
  if (container) {
    container.removeAttribute('tabindex');
  }

  document.removeEventListener('focusin', this.listeners[namespace]);
}


var AnnouncementBarHeaderSection = function () {
  function AnnouncementBarHeaderSection(element) {
    _classCallCheck(this, AnnouncementBarHeaderSection);

    this.element = element;
    this.domDelegate = new domDelegate.Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.isOpen = false;

    // We set the new width of the announcement bar button if any
    if (this.options['showNewsletter']) {
      document.documentElement.style.setProperty('--announcement-bar-button-width', this.element.querySelector('.js-toggle-newsletter').clientWidth + 'px');
    } else {
      document.documentElement.style.removeProperty('--announcement-bar-button-width');
    }

    this._attachListeners();
  }

  _createClass(AnnouncementBarHeaderSection, [{
    key: 'onSelect',
    value: function onSelect() {
      if (this.options['showNewsletter'] && !this.isOpen) {
        this._toggleNewsletter();
      }
    }
  }, {
    key: 'onDeselect',
    value: function onDeselect() {
      if (this.options['showNewsletter'] && this.isOpen) {
        this._toggleNewsletter();
      }
    }
  }, {
    key: 'onUnload',
    value: function onUnload() {
      this.domDelegate.off();
    }
  }, {
    key: '_attachListeners',
    value: function _attachListeners() {
      this.domDelegate.on('click', '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this));
      this.domDelegate.on('keyup', this._handleKey.bind(this));
    }
  }, {
    key: '_toggleNewsletter',
    value: function _toggleNewsletter() {
      var togglerElement = this.element.querySelector('.js-toggle-newsletter'),
          newsletterElement = this.element.querySelector('.announcement-bar__newsletter');

      if (togglerElement.getAttribute('aria-expanded') === 'false') {
        togglerElement.setAttribute('aria-expanded', 'true');
        newsletterElement.setAttribute('aria-hidden', 'false');

        newsletterSlideDown(newsletterElement, function() {
        	// a11y
          	newsletterTrapFocus(newsletterElement, 'announcement-bar-newsletter')
        });
        
//         __WEBPACK_IMPORTED_MODULE_1__helper_Animation__["default"].slideDown(newsletterElement, function () {
//           __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].trapFocus(newsletterElement, 'announcement-bar');
//         });
      } else {
        togglerElement.setAttribute('aria-expanded', 'false');
        newsletterElement.setAttribute('aria-hidden', 'true');
        
        newsletterSlideUp(newsletterElement);
        newsletterRemoveTrapFocus(newsletterElement, 'announcement-bar-newsletter')

//         __WEBPACK_IMPORTED_MODULE_1__helper_Animation__["default"].slideUp(newsletterElement);
//         __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].removeTrapFocus(newsletterElement, 'announcement-bar');
      }

      this.isOpen = !this.isOpen;
    }
  }, {
    key: '_handleKey',
    value: function _handleKey(event) {
      if (event.keyCode === 27 && this.isOpen) {
        this._toggleNewsletter();
      }
    }
  }]);

  return AnnouncementBarHeaderSection;
  
}();

new AnnouncementBarHeaderSection(document.querySelector('[data-section-id="header"]'));



  
  
  /**
   * OverflowScroller ES5 class.
   */

  function OverflowScroller(element, options) {
     this.element = element;
      this.options = options;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset =
        options["offsetTop"] ||
        parseInt(window.getComputedStyle(this.element).top);
      this.attachListeners();
  }

  OverflowScroller.prototype.destroy = function() {
    window.removeEventListener("scroll", this.checkPositionListener);
  };

  OverflowScroller.prototype.attachListeners = function() {
    this.checkPositionListener = this.checkPosition.bind(this);
    window.addEventListener("scroll", this.checkPositionListener);
  };

  OverflowScroller.prototype.checkPosition = function() {
    var $this = this;

      fastdom.measure(function () {
        var bounds = $this.element.getBoundingClientRect(),
          maxTop =
            bounds.top +
            window.scrollY -
            $this.element.offsetTop +
            $this.initialTopOffset,
          minTop =
            $this.element.clientHeight -
            window.innerHeight +
            ($this.options["offsetBottom"] || 0);

        if (window.scrollY < $this.lastKnownY) {
          $this.currentTop -= window.scrollY - $this.lastKnownY;
        } else {
          $this.currentTop += $this.lastKnownY - window.scrollY;
        }

        $this.currentTop = Math.min(
          Math.max($this.currentTop, -minTop),
          maxTop,
          $this.initialTopOffset
        );
        $this.lastKnownY = window.scrollY;
      });

      fastdom.mutate(function () {
        $this.element.style.top = $this.currentTop + "px";
      });
  };


  document.addEventListener('DOMContentLoaded', function() {
    var sidebar = new OverflowScroller(document.querySelector(".desktop-filters"), {
      offsetTop: 0,
      offsetBottom: 30
    });
    
  });

  /* FastDom https://github.com/wilsonpage/fastdom */
  !function(t){"use strict";function e(){var e=this;e.reads=[],e.writes=[],e.raf=u.bind(t)}function n(t){t.scheduled||(t.scheduled=!0,t.raf(i.bind(null,t)))}function i(t){var e,i=t.writes,o=t.reads;try{o.length,r(o),i.length,r(i)}catch(t){e=t}if(t.scheduled=!1,(o.length||i.length)&&n(t),e){if(e.message,!t.catch)throw e;t.catch(e)}}function r(t){for(var e;e=t.shift();)e()}function o(t,e){var n=t.indexOf(e);return!!~n&&!!t.splice(n,1)}function s(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}var u=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)};e.prototype={constructor:e,measure:function(t,e){var i=e?t.bind(e):t;return this.reads.push(i),n(this),i},mutate:function(t,e){var i=e?t.bind(e):t;return this.writes.push(i),n(this),i},clear:function(t){return o(this.reads,t)||o(this.writes,t)},extend:function(t){if("object"!=typeof t)throw new Error("expected object");var e=Object.create(this);return s(e,t),e.fastdom=this,e.initialize&&e.initialize(),e},catch:null};var exports=t.fastdom=t.fastdom||new e;"function"==typeof define?define(function(){return exports}):"object"==typeof module&&(module.exports=exports)}("undefined"!=typeof window?window:this);

